import { render, staticRenderFns } from "./ForgotPasswordReset.vue?vue&type=template&id=f5995d02&scoped=true&"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordReset.vue?vue&type=style&index=0&id=f5995d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5995d02",
  null
  
)

export default component.exports